export const applyFilters = (data, filters) => {
  return data.filter(item => {
    // Apply all filters. If all filters return true, include the item.
    return filters.every(filter => filter(item));
  });
};

// Helper function to access nested values using dot notation
const getValueByPath = (obj, path) => {
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
};

// Search filter (case-insensitive search across specified keys)
export const createSearchFilter = (search, keysToFilter = []) => {
  return (item) => {
    if (!search) return true; // If no search term, include all items

    const lowerSearch = search.toLowerCase();

    return keysToFilter.length > 0
      ? keysToFilter.some(key => {
          const value = getValueByPath(item, key);
          return String(value ?? '').toLowerCase().includes(lowerSearch);
        })
      : Object.values(item).some(value =>
          String(value).toLowerCase().includes(lowerSearch)
        );
  };
};

// Status filter (Active/Inactive)
export const createStatusFilter = (status, activeText = "Active", key = "status") => {
  return (item) => {
    if (status === "All") return true; // If status is "All", include all items
    return item[key] === (status === activeText);
  };
};

// Date range filter (dateFrom and dateTo)
export const createDateRangeFilter = (dateFrom, dateTo, dateKey) => {
  return (item) => {
    if (!dateFrom && !dateTo) return true; // If no date range, include all items
    const itemDate = new Date(item[dateKey]);
    return (
      (!dateFrom || itemDate >= new Date(dateFrom)) &&
      (!dateTo || itemDate <= new Date(dateTo))
    );
  };
};

// Year and Month filter for multiple date keys
export const createYearMonthFilter = (year, month, dateKeys) => {
  return (item) => {
    if (!year || !month || dateKeys.length === 0) {
      return true; // If no year, month, or date keys are provided, include all items
    }

    // Check if any of the date keys match the specified year and month
    return dateKeys.some((key) => {
      const itemDate = new Date(item[key]);
      if (isNaN(itemDate)) return false; // Skip invalid dates

      const itemYear = itemDate.getFullYear();
      const itemMonth = itemDate.getMonth(); // getMonth() returns 0-11

      return itemYear === year && itemMonth === month;
    });
  };
};

// Custom filter (search based on provided value and keys)
export const createCustomFilter = (value, key, isNested = false) => {
  return (item) => {
    if (!value) {
      return true
    };
    if(!isNested){
      return item[key] === value;
    }
    else {
      return getNestedValue(item, key) === value;
    }
  };
};

// const getNestedValue = (obj, keyPath) => {
//   return keyPath.split('.').reduce((acc, key) => acc && acc[key], obj);
// };

// Helper function to get nested values, including array indices and optional chaining

const getNestedValue = (obj, path) => {
  return path.split('.').reduce((acc, part) => {
    if (acc == null) return undefined; // Handle optional chaining
    // Handle array indices (e.g., posts[0])
    const match = part.match(/(.*)\[(\d+)\]/);
    if (match) {
      const key = match[1];
      const index = parseInt(match[2], 10);
      return acc[key]?.[index]; // Optional chaining for arrays
    }
    return acc[part];
  }, obj);
};
